module.exports = __webpack_public_path__ + "img/yaph.26ffccd0.jpg";